import { fus } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function updateBalance () {
  return fus.post('balance.do', {
    userKey: sessionStorage.getItem('userKey')
  }).then((res) => {
    return checkLimitedUser(res)
  });
}

export { updateBalance }